define('CustomCategory.Model', [
  'Backbone',
  'Utils'
], function (
  Backbone,
  Utils
) {
  'use strict';

  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
        getExtensionAssetsPath(
            "services/CustomCategory.Service.ss"
        )
    )
  });
});
